import { subscriberIdApi } from '../../store';
import { formatSubscriberIdApiUrl } from '../../utils/formatApiUrl';
import { productCategoriesMapping } from './mapping';
import { IProductAccordions, IProductListQuery } from './types';

export const productsApi = subscriberIdApi.injectEndpoints({
    endpoints: (builder) => ({
        getProductList: builder.query<IProductAccordions[], IProductListQuery>({
            async queryFn(arg, _queryApi, _extraOptions, baseQuery) {
                const list = await baseQuery(formatSubscriberIdApiUrl(arg.subscriberId, 'products/list'));
                const categories = await baseQuery(formatSubscriberIdApiUrl(arg.subscriberId, 'products/categories'));

                if (list.error) throw list.error;
                if (categories.error) throw categories.error;

                let data = [];
                try {
                    data = productCategoriesMapping(categories.data, list.data, arg.servicesCategoryId);
                } catch (e) {
                    throw e;
                }

                return { data };
            },
        }),
    }),
});

export const {
    useGetProductListQuery,
} = productsApi;
